import React from "react"
import { Button, Menu, MenuItem } from "@mui/material"
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown"
import { useLocation } from "react-router-dom"
import { Link } from "react-router-dom"

// menu item: { label, link } หรือกลุ่ม { label, children: [{ label, link }] }
const activeSx = (active) => ({
  borderBottomWidth: active ? "3px" : "0px",
  borderBottomStyle: "solid",
  borderBottomColor: "white",
  borderRadius: 0,
  whiteSpace: "nowrap",
})

const NavGroup = ({ menu }) => {
  const location = useLocation()
  const [anchorEl, setAnchorEl] = React.useState(null)
  const active = menu.children.some((c) => c.link === location.pathname)

  return (
    <>
      <Button
        color="inherit"
        endIcon={<KeyboardArrowDownIcon />}
        onClick={(e) => setAnchorEl(e.currentTarget)}
        sx={activeSx(active)}
      >
        {menu.label}
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
      >
        {menu.children.map((child) => (
          <MenuItem
            key={child.link}
            component={Link}
            to={child.link}
            selected={location.pathname === child.link}
            onClick={() => setAnchorEl(null)}
          >
            {child.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  )
}

const NavMenu = ({ menu }) => {
  const location = useLocation()

  return (
    <>
      {menu.map((menu) =>
        menu.children ? (
          <NavGroup key={menu.label} menu={menu} />
        ) : (
          <Button
            color="inherit"
            component={Link}
            to={menu.link}
            key={menu.link}
            sx={activeSx(location.pathname === menu.link)}
          >
            {menu.label}
          </Button>
        ),
      )}
    </>
  )
}

export default NavMenu
